import { useState } from "react";
import { useQuery } from "react-query";
import { getUsers } from "services/user.service";
import { UserQuery } from "types/user.type";

export default function useUsers(defaultQuery?: UserQuery) {
  const [query, setQuery] = useState<UserQuery>(
    defaultQuery || {
      page: 1,
      limit: 20,
      search: "",
    }
  );

  // Keyed on the whole query, not just page and search. The segment pages vary
  // `role` and `kycStatus`, and with those left out of the key react-query
  // served the previous segment's rows from cache under the new heading.
  const { isLoading, data, refetch } = useQuery(["users", query], async () =>
    getUsers(query)
  );

  const onQueryChange = (name: keyof UserQuery, value: string | number) => {
    // Any change to a filter invalidates the page you were on: staying on page
    // 4 of a list that now has one page shows nothing at all.
    setQuery((q) => ({ ...q, [name]: value, ...(name === "page" ? {} : { page: 1 }) }));
  };

  const onFilter = (queryFilter: UserQuery) => {
    setQuery(queryFilter);
  };

  return { isLoading, data, onQueryChange, onFilter, refetch, query };
}
